import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import CircularProgress from "@mui/material/CircularProgress";
import { useSharedValue } from "../components/Constants/constants";
import { useUserSettings } from "../contexts/UserSettingsContext";
import { BASE_URL, appVersion } from "../App_Settings/app_settings";
import { useMsal, useIsAuthenticated } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import "./Login.css";
import "../components/Constants/config.css";

const Login = () => {
  const history = useHistory();
  const { updateDirectNavigation, handleNotificationList, handleSelectedRows } = useSharedValue();
  const { refreshSettings } = useUserSettings();
  const { instance, accounts } = useMsal();
  const isMsalAuthenticated = useIsAuthenticated();

  useEffect(() => {
    const handler = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handler);
    return () => document.removeEventListener("contextmenu", handler);
  }, []);

  // Prevent back button from returning to /dashboard after logout

  // Complete SSO when MSAL already has an authenticated session
  useEffect(() => {
    const completeSsoLogin = async () => {
      if (!isMsalAuthenticated || accounts.length === 0) return;
      if (sessionStorage.getItem("ssoLoginInProgress")) return;
      if (localStorage.getItem("token") && localStorage.getItem("sessionToken")) {
        history.push({ pathname: "/dashboard", state: { someValue: true } });
        return;
      }
      sessionStorage.setItem("ssoLoginInProgress", "1");
      try {
        const tokenResponse = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0],
        });
        const res = await fetch(`${BASE_URL}/users/ssoauthenticate`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenResponse.idToken}`,
          },
        });
        const data = await res.json();
        if (!res.ok) {
          sessionStorage.removeItem("ssoLoginInProgress");
          alert(data.message || "SSO authentication failed. Please contact your admin.");
          instance.logoutRedirect({ postLogoutRedirectUri: window.location.origin });
          return;
        }
        localStorage.setItem("token", JSON.stringify(data));
        localStorage.setItem("loginMethod", "sso");
        if (data.sessionToken) localStorage.setItem("sessionToken", data.sessionToken);
        localStorage.removeItem("SelectedFilesList");
        localStorage.removeItem("notifications_list");
        localStorage.removeItem("preventAutoSSO");
        sessionStorage.removeItem("ssoLoginInProgress");
        handleNotificationList([]);
        handleSelectedRows([]);
        updateDirectNavigation(true);
        if (refreshSettings) await refreshSettings();
        history.push({ pathname: "/dashboard", state: { someValue: true } });
      } catch (err) {
        sessionStorage.removeItem("ssoLoginInProgress");
        instance.loginRedirect(loginRequest).catch(() => {});
      }
    };
    completeSsoLogin();
  }, [
    isMsalAuthenticated,
    accounts,
    instance,
    history,
    handleNotificationList,
    handleSelectedRows,
    refreshSettings,
    updateDirectNavigation,
  ]);

  // Always auto-redirect to Microsoft — no login card ever shown
  useEffect(() => {
    if (isMsalAuthenticated) return;
    if (sessionStorage.getItem("ssoLoginInProgress")) return;
    localStorage.removeItem("preventAutoSSO");
    instance.loginRedirect(loginRequest).catch(() => {});
  }, [isMsalAuthenticated, instance]);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundImage: "var(--login-bg-image)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <CircularProgress style={{ color: "#fff" }} size={40} />
      <span
        style={{
          position: "fixed",
          bottom: 10,
          right: 14,
          color: "#ffffff",
          fontSize: "12px",
          pointerEvents: "none",
        }}
      >
        VERSION: {appVersion}
      </span>
    </div>
  );
};

export default Login;
